import { useEffect, useRef, useState } from "react"

interface DoubleClickableTextLineProps {
  item: Layer,
  layerAction: (layer: Layer) => void,
  setInsertNameActive: (b: boolean) => void,
  immediateEdit?: boolean
}
function DoubleClickableTextLine({
  setInsertNameActive,
  layerAction,
  item,
  immediateEdit }: Readonly<DoubleClickableTextLineProps>) {
  const [isEditing, setIsEditing] = useState(immediateEdit || false)
  function endInput(name: string) {
    setIsEditing(false)
    setInsertNameActive(false)
    if (item.name !== name) {
      layerAction({ ...item, name: name, visibility: true })
    };
  }

  return (
    <span className="listFlexElement" onDoubleClick={() => { setIsEditing(true) }}>
      {isEditing ? <InputTextSection
        inputText={item.name}
        setIsEditing={setIsEditing}
        endInput={endInput} />
        :
        <span className="listText">{item.name}</span>}
    </span>
  )
}

interface InputTextSectionProps {
  inputText: string,
  setIsEditing: (isEditing: boolean) => void;
  endInput: (name: string) => void

}
const InputTextSection = ({
  inputText,
  setIsEditing,
  endInput }: InputTextSectionProps
) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [text, setText] = useState(inputText)

  useEffect(() => {
    inputRef.current?.select();
  }, [inputRef])

  return (

    <input
    className="listText"
      ref={inputRef}
      type="text"
      value={text}
      onChange={e => (setText(e.currentTarget.value))}
      onBlur={e => { endInput(text) }}
      onKeyDown={
        e => {
          if (e.key === "Enter") endInput(text)
          if (e.key === "Escape") setIsEditing(false)
        }}
    />
  )
}
export default DoubleClickableTextLine